import React from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-bootstrap'
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import '../style.css'

import {
  handleICUAdmissionOrganSupportFieldChange,
  submitOrganSupport,
  deleteOrganSupport,
 } from '../reducers/antibioticsUseFormReducer'

import ConfirmationPopover from '../../../components/ConfirmationPopover'

const ICUAdmissionOrganSupport = (props) => {

  const {
    id,
    name,
    start_date,
    end_date,
    reason,
    chartForReview,
  } = props

  const handleChange = (e) => {
    props.handleICUAdmissionOrganSupportFieldChange(id, e.target.name, e.target.value, props)
  }

  const handleDateChange = (dateName, date) => {
    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const updatedProps = {
        ...props,
        [dateName]: date,
        dateValidationErrorMessagestart_date: '',
        dateValidationErrorMessageend_date: '',
      }
      // props.handleICUAdmissionOrganSupportFieldChange(id, dateName, date, updatedProps)
      return props.submitOrganSupport(updatedProps, dateName)
    }
  }

  const handleBlur = () => {
    props.submitOrganSupport(props)
  }

  const handleRemove = () => {
    return props.deleteOrganSupport(props)
  }

  const getDateValidationMessage = (date, dateName) => {
    if (props[`dateValidationErrorMessage${dateName}`]) {
      return props[`dateValidationErrorMessage${dateName}`]
    }
    if (date) {
      return 'Date is valid'
    }
    return 'Date is invalid'
  }

  const popoverContent = (
    <div>
      <p>Remove <strong>{name}</strong>?</p>
      <br/>
      <p>
        This action will <strong>delete the organ support instance from the database</strong>.
      </p>
    </div>
  )

  let datePickerFormat = "MMMM d,  yyyy"

  return (
    <tr className="antimicrobial-row">
      {chartForReview ?
        null
        :
        <td className='form-input-td'>
          <center>
            <ConfirmationPopover
              triggerText='x'
              title='Delete Row?'
              placement='right'
              popoverContent={popoverContent}
              onConfirm={handleRemove}
            />
          </center>
        </td>
      }

      <td className='form-input-td'>
        {props.showNameAsForm ?
          <Form.Control
            type='text'
            name='name'
            value={name}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder='Enter support type'
            disabled={props.chartForReview}
            required={true}
          />
          :
          name
        }
      </td>


      <td className='date-td'>
       <MuiPickersUtilsProvider utils={DateFnsUtils}>
         <KeyboardDatePicker
           style={{ background: 'white' }}
           disabled={props.chartForReview}
           variant="inline"
           margin="normal"
           format={datePickerFormat}
           value={start_date}
           autoOk={true}
           required={true}
           helperText={getDateValidationMessage(start_date, 'start_date')}
           onChange={(date) => handleDateChange('start_date', date)}
           KeyboardButtonProps={{
             'aria-label': 'change date',
           }}
         />
       </MuiPickersUtilsProvider>
      </td>

      <td className='date-td'>
       <MuiPickersUtilsProvider utils={DateFnsUtils}>
         <KeyboardDatePicker
           style={{ background: 'white' }}
           disabled={props.chartForReview}
           variant="inline"
           margin="normal"
           format={datePickerFormat}
           value={end_date}
           autoOk={true}
           required={true}
           helperText={getDateValidationMessage(end_date, 'end_date')}
           onChange={(date) => handleDateChange('end_date', date)}
           KeyboardButtonProps={{
             'aria-label': 'change date',
           }}
         />
       </MuiPickersUtilsProvider>
      </td>

      <td className='form-input-td'>
        <Form.Control
          type='text'
          name='reason'
          value={reason}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='reason'
          disabled={props.chartForReview}
          required
        />
      </td>
    </tr>
  )
}

const mapStateToProps = (state) => {
  return {
    // antibiotics_use: state.antibioticsUseFormReducer.antibioticsUseInfoUrl,
    // currentUser: state.loginReducer.currentUser,
  }
}


const mapDispatchToProps = {
  handleICUAdmissionOrganSupportFieldChange,
  submitOrganSupport,
  deleteOrganSupport,
}


export default connect(mapStateToProps, mapDispatchToProps)(ICUAdmissionOrganSupport)
